export function PreferredDriverEmptyState() {
  return (
    <div className="flex items-center justify-center py-8 text-sm text-gray-500">
      No driver preferences added yet.
    </div>
  );
}
